/**
 * Format Malaysian phone number as user types.
 * Output: 012-345 6789 or 03-1234 5678
 * Strips all non-digits, then applies formatting.
 */
export function formatPhoneNumber(value) {
    let digits = (value || '').replace(/\D/g, '');

    // Strip country code 60 → 0
    if (digits.startsWith('60') && digits.length > 4) {
        digits = '0' + digits.slice(2);
    }

    // Mobile: starts with 01 (e.g., 012, 011, 013, etc.)
    if (digits.startsWith('01')) {
        if (digits.length <= 3) return digits;
        if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
        return `${digits.slice(0, 3)}-${digits.slice(3, 7)} ${digits.slice(7, 11)}`;
    }

    // Landline: starts with 0 (e.g., 03, 04, etc.)
    if (digits.startsWith('0')) {
        if (digits.length <= 2) return digits;
        if (digits.length <= 6) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
        return `${digits.slice(0, 2)}-${digits.slice(2, 6)} ${digits.slice(6, 10)}`;
    }

    return digits;
}

/**
 * Strip formatting and return raw digits for storage.
 */
export function stripPhoneFormat(value) {
    return (value || '').replace(/\D/g, '');
}

/**
 * A Malaysian mobile as WhatsApp wants it: digits only, country code, no plus.
 * People key them in every shape there is — "012-720 7546", "+60127207546",
 * "60 12 7207546" — and wa.me accepts exactly one of those.
 *
 * Lives here rather than in the timeline card because the Scheduling board sends the
 * same message from a table row, and two copies would drift the day somebody fixes a
 * number format in one of them.
 */
export function waNumber(raw) {
    const digits = String(raw || '').replace(/\D/g, '');
    if (!digits) return '';
    if (digits.startsWith('60')) return digits;
    if (digits.startsWith('0')) return '60' + digits.slice(1);
    return '60' + digits;
}

/**
 * Opens WhatsApp with the message written and the customer's number already in it — a
 * draft, not a send, so whoever presses it is still the one talking. Opens nothing and
 * returns false when there is no number on the customer.
 */
export function openWhatsApp(phone, text) {
    const to = waNumber(phone);
    if (!to) return false;
    window.open(`https://wa.me/${to}?text=${encodeURIComponent(text || '')}`, '_blank');
    return true;
}
